import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Upload } from './upload/upload';
import { About } from './about/about';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: Upload },
  { path: 'about', component: About }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
